//   This files handles the parsing of the categories being followed

export function parseAdBusinessUnits(adBusinessUnits) {
  return adBusinessUnits;
}
